export const getPortletNameCSSClass = (portletConfig) => {
    const { portletType, cashierType } = portletConfig;

    let portletNameCSSClassGeneral = '';
    let portletNameCSSClassExtended = '';

    if (portletType) {
        portletNameCSSClassGeneral = `portlet_name_${portletType.replace(/_/g, '-')}`;
    } else {
        return '';
    }

    if (cashierType) {
        portletNameCSSClassExtended = `${portletNameCSSClassGeneral}--${cashierType.replace(/_/g, '-')}`;
    }

    return `${portletNameCSSClassGeneral} ${portletNameCSSClassExtended}`.trim().toLowerCase();
};

export const getPortletWrapperCSSClassNames = (portletConfig, additionalClassNames, showWrapper, customCSSClassName) => {
    const { showTitle, portletType, portletId } = portletConfig;
    const classList = [
        'portlet',
        getPortletNameCSSClass(portletConfig),
        'portlet-wrapper',
        'fn-portlet-wrapper',
        'portlet-boundary',
        `portlet-boundary_${portletId}_`,
        portletType ? `portlet-${portletType}` : '',
        portletType ? `${portletType}` : '',
        showTitle && showWrapper ? 'portlet_type_border' : 'portlet_type_no-border',
        ...additionalClassNames,
        customCSSClassName
    ];

    return classList.join(' ');
};

export const getPortletCSSClassNames = (portletConfig) => {
    const { showTitle, portletType } = portletConfig;
    const classList = [
        'fn-portlet',
        'portlet__content',
        `portlet__content_border_${showTitle ? 'show' : 'none'}`,
        portletType ? `portlet__content_type_${portletType}` : ''
    ];

    return classList.join(' ');
};

export const getPortletTkPrefix = type => `playtech.mobile.${type}.`;
